import { selectFeatureFlag } from '../../selectors/feature-flags';

export const getPageSizeTrailersHealth = state => selectFeatureFlag(state, 'page-size-trailers-health');
